import Isotope from "isotope-layout"
import IsotopePackery from "isotope-packery"
import imagesLoaded from "imagesloaded"

function initGrid() {
  const grid = document.querySelector('.grid');
  if (grid == null) return;

  let iso = new Isotope( grid, {
    layoutMode: 'packery',
    itemSelector: '.grid-item',
  });
}

function fadeInGrid() {
  const grid = document.querySelector(".grid");
  if (grid == null) return;

  imagesLoaded(grid, function( instance ) {
    console.info("images loaded!")
    grid.classList.add("grid-fade-in");
  });
}


window.addEventListener('load', function () {
  initGrid();
  fadeInGrid();
}, false);
